import React, { ReactNode, ComponentPropsWithoutRef } from "react";

import "./PlainButton.scss";

interface PlainButtonProps extends ComponentPropsWithoutRef<"button"> {
  children: ReactNode;
}

export const PlainButton = ({ children, ...attrs }: PlainButtonProps) => {
  return (
    <button className="plain-button" {...attrs}>
      {children}
    </button>
  );
};
